import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { TextGroup, TextGroup2, Card, Text, TextTypes, Icon, Badge, BadgeVariants } from '../index';
import { GiftCard } from '../../types/graphql-global-types';
import CardWrapper, { CardProps } from './card-wrapper';

interface CardDesktopProps extends CardProps {
    lineitems: GiftCard[];
    balance: () => HTMLElement;
    cardImage: () => HTMLElement;
    deliveryDate: () => JSX.Element;
}

const CardDesktop = ({ card, lineitems, ...props }: CardDesktopProps) => {
    const recipient = card.cardrecipientinfo;
    const gcnumber = card.cleansedgcnumber?.slice(-7);
    const carddetid = card.reissuecarddet?.carddetid;

    const [expanded, setExpanded] = useState(true);

    const reissuedBy = () => {
        let index = lineitems.findIndex((x) => x.carddetid === carddetid);
        if (index > -1) {
            return lineitems[index].cleansedgcnumber?.slice(-4);
        }
        return '';
    };

    return (
        <Card className={'order-card ' + (expanded ? 'expanded' : 'collapsed')}>
            {card.reissuecarddet && (
                <span className="badge">
                    <Badge text={'Reissued by ' + reissuedBy()} variant={BadgeVariants.GRAY} />
                </span>
            )}
            <Container fluid className={carddetid ? 'reissued' : ''}>
                <Row>
                    <Col md={4}>
                        <div className="d-flex card-head" onClick={() => setExpanded(!expanded)}>
                            {expanded ? (
                                <Icon name="DownIcon" alt="" size={45} className="down-arrow" />
                            ) : (
                                <Icon name="RightIcon" alt="" size={45} className="right-arrow" />
                            )}
                            <Text type={TextTypes.H4} className="card-name">
                                Card #{gcnumber}
                            </Text>
                        </div>
                        {expanded && props.cardImage()}
                    </Col>
                    {expanded && (
                        <Col md={8} className="card-info">
                            <Row>
                                <TextGroup2
                                    label="Original Card Value"
                                    value={'$' + (card.denomination?.toFixed(2) || '')}
                                />
                                <TextGroup2 label="Current Balance" value={props.balance()} />
                                <Col />
                            </Row>
                            <Row>
                                <Col md={4} style={{ padding: 0 }}>
                                    <TextGroup
                                        label="Recipient"
                                        value={
                                            <span className="recipient">
                                                <span>{recipient?.recipientname}</span>
                                                <span>{recipient?.recipientemail}</span>
                                            </span>
                                        }
                                    />
                                </Col>
                                {card.personalmessage && (
                                    <TextGroup label="Message" value={card.personalmessage} />
                                )}
                                <Col>{props.deliveryDate()}</Col>
                            </Row>
                        </Col>
                    )}
                </Row>
            </Container>
        </Card>
    );
};

export default CardWrapper(CardDesktop);
